import { ImportColumnModel } from "@models/common/importColumnModel"
import http from "../httpService"
import { notifySuccess } from "@lib/helper"
import { LNotification } from "@lib/abpUtility"
import { getOptionsFromEnum, ModuleEnum } from "@lib/enum"
import { downloadFile } from "@lib/helperFile"
import dayjs from "dayjs"

const moduleEnumOptions = getOptionsFromEnum(ModuleEnum)
class ImportService {
  // Export
  public async getExportConfiguration(module: any): Promise<any[]> {
    const res = await http.get(
      "api/services/app/Import/GetExportConfiguration",
      { params: { module } }
    )
    return res.data.result
  }
  // Export by module
  public async exportUnit(params: any, payload: any): Promise<any> {
    const res = await http.post("api/Export/ExportUnitV2", [...payload], {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-UNIT-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }
  public async exportCustomer(params: any, payload: any): Promise<any> {
    const res = await http.post("api/Export/ExportCustomer", [...payload], {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-CUSTOMER-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }
  public async exportUnitPricingApproval(params: any): Promise<any> {
    const res = await http.post(
      "api/Export/PricingApproval/ExportUnit",
      {},
      {
        params,
        responseType: "blob",
      }
    )
    downloadFile(res.data, `EXPORT-UNIT-PRICING-APPROVAL-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async validatePricingApprovalBeforeImport(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)
    const result = await http.post(
      "api/Imports/PricingApproval/ValidateBeforeImport",
      formData,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    )
    {
      notifySuccess(
        LNotification("SUCCESS"),
        LNotification("IMPORT_SUCCESSFULLY")
      )
    }
    return result.data.result
  }

  // BOoking

  public async exportBooking(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportBooking", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-BOOKING-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  //handover reservation
  public async exportHandoverReservation(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportHandoverReservation", {
      params,
      responseType: "blob",
    })
    downloadFile(
      res.data,
      `EXPORT-HANDOVER-RESERVATION-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`
    )
  }

  // Template excel
  public async getTemplate(module: ModuleEnum): Promise<any> {
    const res = await http.get("api/Imports/GetTemplate", {
      params: { module },
      responseType: "blob",
    })
    const moduleName = moduleEnumOptions.find(
      (item) => item.value === module
    )?.label
    downloadFile(
      res.data,
      `IMPORT-TEMPLATE-${moduleName}-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`
    )
  }

  public async exportFeedback(params: any, payload: any): Promise<any> {
    // const res = await http.post("api/Export/ExportFeedback", [...payload], {
    //   params,
    //   responseType: "blob",
    // })
    // downloadFile(res.data, `feedback_${dayjs().format("DDMMYYYY")}.xlsx`)
  }

  // Import
  public async getModelValidation(module: any): Promise<ImportColumnModel[]> {
    const res = await http.get("api/services/app/Import/GetModelValidation", {
      params: { module },
    })
    return res.data.result
  }
  public async import(body: any, module: ModuleEnum) {
    let url
    switch (module) {
      case ModuleEnum.UNIT:
        url = "api/services/app/Import/ImportUnit"
        break
      case ModuleEnum.CUSTOMER:
        url = "api/services/app/Import/ImportCustomer"
        break
      default:
      // code block
    }
    if (url) {
      const result = await http.post(url, body)
      notifySuccess(
        LNotification("SUCCESS"),
        LNotification("IMPORT_SUCCESSFULLY")
      )
      return result.data.result
    }
  }

  public async exportSaleEventBooking(params: any): Promise<any> {
    const res = await http.get("api/Export/Export-SalesEvent-BookingInCart", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-SALES-EVENT-BOOKING-IN-CART-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async exportSaleEventBookingOffline(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportSalesEventBookingOffline", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-SALES-EVENT-BOOKING-OFFLINE-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async exportSaleEventBookingOnline(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportSalesEventBookingOnline", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-SALES-EVENT-BOOKING-ONLINE-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async exportTemplateProductsInCart(params?: any, name?: string): Promise<any> {
    const res = await http.get("api/Export/ExportTemplateImportProductInCart", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `${name || "EXPORT-TEMPLATE-PRODUCTS-IN-CART"}-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async exportSaleEventBookingDailySales(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportBookingForImportContractTemplate", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-SALES-EVENT-BOOKING-DAILY-SALES-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async ValidateBeforeImportBookingToContract(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)
    const result = await http.post(
      "api/Imports/Contract/ValidateBeforeImportBookingToContract",
      formData,
    )
    return result.data.result
  }

  public async validateBeforeImportUnitType(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)
    const result = await http.post(
      "api/Imports/UnitType/ValidateBeforeImport",
      formData,
    )
    return result.data.result
  }


}

export default new ImportService()
